:host {
  padding: 10px 0;
  height: 100%;
  color: var(--av-color-tray);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  direction: var(--av-direction);

  av-agent {
    margin: 0 10px;
    &.av-agent-mobile {
      margin: 0 5px;
    }
  }

  .blink {
    @include animate(blink, 2s, infinite, linear);
    @include animation-blink();
  }

  .timer-container {
    margin-top: 5px;
    color: var(--av-color-tray);
  }

  .av-mic,
  .av-display-capture {
    --av-container-round-width: calc(var(--av-font-size) * 3.3334); // 50px;
    --av-container-round-height: calc(var(--av-font-size) * 3.3334); // 50px;
  }

  .call-info {
    margin: 0 10px;
  }

  // .av-icon {
  //   width: 20px;
  //   height: 20px;
  //   padding: 10px;
  //   display: block;
  //   border-radius: 20px;
  // }
  // .av-icon-online {
  //   background-color: $green;
  // }
  .spinner-container {
    position: absolute;
    right: -15px;
    top: -13px;
    transform: scale(0.3);
  }
}

.av-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  padding:0 5px;
}
